export const SET_ERROR = 'qrator/SET_ERROR';
export const RESET_ERROR = 'qrator/RESET_ERROR';

export const setQratorSupportId = (supportId) => ({ type: SET_ERROR, payload: supportId });
export const resetQratorSupportId = () => ({ type: RESET_ERROR });
